export const AttributeDataType = {
  integer: 1,
  float: 2,
  string: 3,
  date: 4,
  datetime: 5,
};

export const AttributeID = {
  qty: 3,
  ip: 4,
  serialNumber: 6,
  imei: 7,
  bigEndian: 10,
  port: 11,
  device: 12,
  registerData: 13,
  registerSerial: 14,
  baudRate: 15,
  parity: 16,
  ct_primary: 17,
  ct_secondary: 18,
  stopbits: 19,
  databits: 20,
  index: 21,
  readFreq: 22,
  measureID: 29,
  sync15min: 35,
  activeLogger: 36
};

export class DeviceAttribute {

  public id?: number;
  public name?: string;
  public type?: number;
  public config?: string;
  public modified?: string;
  public modifiedBy?: string;

  constructor (data?: any) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.modified = data.modified;
      this.modifiedBy = data.modifiedBy;
      this.type = data.type;
      this.config = data.config;
    }
  }
}
